/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import { Component, Vue } from 'vue-property-decorator';
import LanguageSelector from '@/components/LanguageSelector/index.vue';

/**
 * Site footer component.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-pre-footer',
    components: {
        'c-language-selector': LanguageSelector,
    },
})
export default class PreFooter extends Vue {
    /**
     * Method used to launch language modal.
     */
    public options(): void {
        this.$modal.show('language-selector');
    }
}
